Array.prototype.max = function () {
  if (this && this.length > 0) {
    return Math.max.apply(null, this);
  }
  return 0;
};

// Required for transpiler to pick it up as a module
export {};
